<template>
  <div class="page custom">
    <span class="top">请选择推荐楼盘</span>
    <div
      v-for="(item, idx) in list"
      :key="idx"
      class="item"
      @click.stop="handleClickItem(item)"
    >
      <img :src="getSrc(item)" class="radio" />
      <div class="right">
        <span class="title">{{ item.housesD }}</span>
        <span class="addr">{{ `项目地址：${item.projAdd}` }}</span>
      </div>
    </div>
    <div class="fixed-bottom-height" />
    <div class="fixed-bottom">
      <div class="submit-btn" @click.stop="handleSelect">
        {{ `确定(${selectNum})` }}
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { getRecomBuildings } from "./api";
import { Toast } from "mint-ui";
import Cookies from "js-cookie";
const { mapMutations, mapState } = createNamespacedHelpers("qmyx");

export default {
  data() {
    return {
      list: []
    };
  },
  computed: {
    ...mapState(["selectBuildings"]),
    selectNum() {
      return this.list.reduce((sum, item) => {
        sum += item.select ? 1 : 0;
        return sum;
      }, 0);
    }
  },
  activated() {
    this.handleLoadData();
  },
  methods: {
    ...mapMutations(["saveSelectBuildings"]),
    async handleLoadData() {
      // TODO 城市名如果获取不到 写死珠海了
      const cityName = Cookies.get("hf_cur_city_name") || "珠海";
      const resp = await getRecomBuildings(cityName);
      const { resuleInfo = [] } = resp;
      for (const r of resuleInfo) {
        r.select = this.selectBuildings.some(
          i => i.housesUuid === r.housesUuid
        );
      }
      this.list = resuleInfo;
    },
    getSrc(item) {
      return (item || {}).select
        ? "https://assets.rurushishi.com/yq-rs-make/huafa/img/radio-select.png"
        : "https://assets.rurushishi.com/yq-rs-make/huafa/img/radio.png";
    },
    handleClickItem(item) {
      const isSelect = (item || {}).select || false;
      if (!isSelect && this.selectNum >= 5) {
        Toast("最多只能选择5个楼盘");
        return;
      }
      if (typeof item === "object" && item != null) {
        this.$set(item, "select", !item.select);
      }
    },
    handleSelect() {
      const selectNum = this.selectNum;
      if (selectNum) {
        const sels = this.list.filter(i => i.select);
        this.saveSelectBuildings(sels);
        this.$router.back();
      } else {
        Toast("请先选择要推荐的楼盘");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
$top-height: 40px;
.custom {
  padding-top: $top-height;
  background: #ffffff;
}
.top {
  width: 100%;
  display: inline-block;
  height: $top-height;
  line-height: 0.8rem;
  position: fixed;
  background: #ffffff;
  top: 0;
  left: 0;
  padding-left: 0.48rem;
  z-index: 1;
}
.item {
  display: flex;
  align-items: flex-start;
  padding: 0.3rem 0;
  box-shadow: 0 0.02rem 0 0 #efefef;
  border-radius: 0.02rem;
  .radio {
    width: 0.4rem;
    height: 0.4rem;
  }
  .right {
    flex: 1;
    display: flex;
    flex-direction: column;
    font-size: 0.26rem;
    margin-left: 0.16rem;
    position: relative;
    .title {
      font-size: 0.3rem;
      color: #222222;
    }
    .addr {
      color: #666666;
      margin: 0.16rem 0 0;
      line-height: 0.34rem;
    }
  }
}
</style>
